import { FormControl, Stack, TextField, Typography, Button, Autocomplete } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Message } from "../../components/Message";
import { useForm } from "../../hooks/useForm";
import { messagesCreateUser, messagesEditUser } from "../../helpers/userMessage";

import './styles.css';

export const CreateUserScreen = ({ data }) => {

    const navigate = useNavigate();

    const [formValues, handleInputChange, reset] = useForm(data ? data[0] : {
        email: '',
        tel: '',
        rol: ''
    });

    const [isSend, setIsSend] = useState(false);
    const [body, setBody] = useState({});

    const { email, tel, rol } = formValues;

    const handleSubmit = (e) => {
        e.preventDefault();
        let obj = {
            email,
            tel,
            rol
    };
    if (data) { obj = {
        email,
        tel, 
        rol,
        id: data[0].id
    }}
        setBody(obj)
        setIsSend(!isSend)
    }


    return (
        <section className="div_section">
            <FormControl component='form' className="form_newUser" onSubmit={handleSubmit}>
                <Stack spacing={4} pt={3} pb={3} alignItems='center' >
                    <Typography textAlign='center' variant="h5" color="primary">{data ? 'Editar Usuario' : 'Crear nuevo usuario'}</Typography>

                    <Stack flexWrap='wrap' alignContent='center' width='100%' gap={1}>
                        <Stack flexDirection='row' flexWrap='wrap' justifyContent='space-around' width='80%' alignItems='flex-end' mb='1rem'>
                            <TextField
                                value={email}
                                name='email'
                                label="Email"
                                type="email"
                                variant="standard"
                                onChange={handleInputChange}
                                required
                            />
                            <TextField
                                value={tel}
                                name='tel'
                                label="Teléfono"
                                type="search"
                                variant="standard"
                                onChange={handleInputChange}
                                required
                            />

                            <Autocomplete
                                disablePortal
                                options={['Gestor', 'Administrador']}
                                sx={{ width: 200, mt: '1rem' }}
                                size='small'
                                value={rol || null}
                                onChange={(event, newValue) => {
                                    handleInputChange({ target: { name: 'rol', value: newValue || '' } });
                                }}
                                renderInput={(params) => <TextField {...params} label="Rol" variant='standard' required />}
                            />
                        </Stack>
                    </Stack>

                    <Stack flexDirection='row' flexWrap='wrap' justifyContent='space-around' width='80%'>
                        <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={() => navigate('/configuration')}>Cancelar</Button>
                        {!data && <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={reset}>Reset</Button>}
                        <Button sx={{ width: '100px' }} variant="outlined" size='small' type='submit'>{data ? 'Editar' : 'Crear'}</Button>
                    </Stack>
                </Stack>

                {isSend && <Message reset={reset} setIsCreate={setIsSend} messages={data ? messagesEditUser : messagesCreateUser} method={data ? 'PUT' :'POST'} body={body} />}
            </FormControl>
        </section>
    )
}
